import { Component, OnInit, ViewChild } from '@angular/core';
import { SortType } from '../../../models/sortType.model';
import { ChecklistItem } from '../../../models/checklist-item.model';
import {
  TableListPage,
} from '../../../models/list-page.model';
import { SubstationService } from '../../../services/substation.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SectionDefinitionEntityType } from '../../../models/section-definition.model';
import { EntityModelCustomizationService } from '../../../services/entity-model-customization.service';
import { Purpose } from '../../../enums/purpose';
import { EmcOptions } from '../../../models/entity-model-customization.model';
import { Filter } from '../../../models/dynamic-filter.model';
import { EmcSearchOutput } from '../../../models/emc-search.model';
import { DynamicCardsComponent } from '../../entity-model-customization/dynamic-cards/dynamic-cards.component';
import { UtilitySharedService } from '../../../services/shared//utility-shared.service';
import { EMCType } from '../../../enums/emc-type';
@Component({
  selector: 'lib-dynamic-substation-list',
  standalone: false,
  templateUrl: './dynamic-substation-list.component.html',
  styleUrls: ['./dynamic-substation-list.component.scss']
})
export class DynamicSubstationListComponent implements OnInit {
  @ViewChild('dynamicCards') dynamicCards!: DynamicCardsComponent;

  constructor(
    private substationService: SubstationService,
    private toastr: ToastrService,
    private router: Router,
    private emcService: EntityModelCustomizationService,
    private utilitySharedService: UtilitySharedService
  ) { }

  entityType: EMCType =
    EMCType.InjectionSubstation;

  mapSortBy: Record<number, string> = {
    [SortType.NEWEST]: 'Newest',
    [SortType.ID_ASC]: 'ID',
    [SortType.ID_DESC]: 'ID',
    [SortType.SLRN_ASC]: 'SLRN',
    [SortType.SLRN_DESC]: 'SLRN',
  };

  mapFilterValues: Record<string, string> = {
    'First Captured User': 'COMMON.USER.TYPE.FIRST_CAPTURED',
    'Last Captured User': 'COMMON.USER.TYPE.LAST_CAPTURED',
    'Reassigned By': 'COMMON.USER.TYPE.REASSIGNED',
    'Validated By': 'COMMON.USER.TYPE.VALIDATED',
    'Audited By': 'COMMON.USER.TYPE.AUDITED',
    Pending: 'COMMON.ASSET_STATUS.PENDING',
    Complete: 'COMMON.ASSET_STATUS.COMPLETE',
    Rejected: 'COMMON.ASSET_STATUS.REJECTED',
    Assigned: 'COMMON.ASSET_STATUS.ASSIGNED',
    'Last Update Time': 'COMMON.DATE_TYPE.LAST_UPDATE',
    'Tagged Date': 'COMMON.DATE_TYPE.TAGGED',
    'Validated Date': 'COMMON.DATE_TYPE.VALIDATED',
    'Audited Date': 'COMMON.MBC_DETAILS.AUDITED_DATE',
    ReviewDate: 'COMMON.MBC_DETAILS.REVIEW_DATE',
  };

  mapFilterLabels: Record<string, string> = {
    Search: 'COMMON.SEARCH',
    'Filter By': 'COMMON.FILTER_BY',
    'User Type': 'COMMON.USER.TYPE.TITLE',
    Type: 'COMMON.TYPE',
    Status: 'COMMON.STATUS',
    'Date From': 'COMMON.DATE_FROM',
    'Date To': 'COMMON.DATE_TO',
    'Date Type': 'COMMON.DATE_TYPE.TITLE',
    Area: 'COMMON.UT.SINGLE',
    User: 'COMMON.USER.SINGLE',
  };

  count: number = 0;
  filter: Filter = new Filter();
  isFilterWindowOpened: boolean = false;
  isDynamicFilterWindowOpened: boolean = false;
  checklistItems: ChecklistItem[] = [];

  tableListPage: TableListPage = new TableListPage();
  emcOptions: EmcOptions[] = [];

  ngOnInit(): void {
    const cachedFilters = localStorage.getItem('filterDynamicSubstations');
    if (cachedFilters) {
      const parsed = JSON.parse(cachedFilters);
      this.filter = parsed;
      this.filter.filterParams.statuses = parsed.filterParams.statuses ?? [];

      this.createFilterCards();
      localStorage.removeItem('filterDynamicSubstations');
    }

    var utilityId = Number(this.utilitySharedService.getUtilityId());

    this.getCardEmcOptions(utilityId);
    this.onPageChange(this.filter.pageInfo.page);
  }

  private getCardEmcOptions(utilityId: number) {
    this.emcService
      .getSelectedEmcOptions(
        SectionDefinitionEntityType.InjectionSubstation,
        Purpose.Card,
        utilityId
      )
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.emcOptions = responseData.data ?? [];
          } else {
            this.toastr.error(
              responseData?.message || 'Failed to fetch EMC options'
            );
          }
        },
        error: (error) => {
          this.toastr.error('Error occurred while fetching EMC options');
        },
      });
  }

  onPageChange(currentPage: number) {
    this.filter.pageInfo.page = currentPage;
    this.reloadTable(currentPage);
  }

  reloadTable(page: number | null = null) {
    if (page) this.filter.pageInfo.page = page;
    this.getAllDynamic(this.filter);
  }


  private getAllDynamic(filter: Filter) {
    this.substationService.getAllDynamic(filter).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        this.tableListPage = responseData.data;
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  onRowClick(guid: string) {
    localStorage.setItem(
      'filterDynamicSubstations',
      JSON.stringify(this.filter)
    );
    this.router.navigate(['asset-list/substations/edit', guid]);
  }

  onDynamicFilterWindowChange(val: boolean) {
    this.isDynamicFilterWindowOpened = val;
  }

  closeDynamicFilterWindow() {
    this.isDynamicFilterWindowOpened = false;
  }

  onFilterWindowChange(val: boolean) {
    this.isFilterWindowOpened = val;
  }

  closeFilterWindow() {
    this.isFilterWindowOpened = false;
  }

  onSortTypeChange(option: SortType) {
    this.filter.filterParams.sortBy = option;
    this.filter.filterParams.sortByName = this.mapSortBy[option];
    this.reloadTable();
  }

  onAddFilterCard(data: ChecklistItem) {
    this.filter.searchObject.searchValue = data.selectedValue;

    this.createFilterCards();
  }

  onAddFilter() {
    this.createFilterCards();
  }

  applyFilter() {
    this.reloadTable(1);
    this.dynamicCards.refresh();
  }

  removeFilter(checklistItem: ChecklistItem) {
    if (checklistItem.property === 'Date Type') {
      return;
    }

    const filter = this.checklistItems.find(
      (f) =>
        f.property === checklistItem.property &&
        f.selectedValue === checklistItem.selectedValue
    );

    if (filter) {
      this.checklistItems = this.checklistItems.filter(f => f !== filter);

      this.updateFilterFromRemovedItem(filter);

      this.createFilterCards();
      if (this.checklistItems.length === 0) {
        this.applyFilter();
      }
    }
  }
  searchfilter(obj: any) {
    this.filter.searchObject = obj;
  }
  resetFilter() {
    this.filter = new Filter();
    this.checklistItems = [];
    this.onPageChange(1);
  }

  private updateFilterFromRemovedItem(item: ChecklistItem) {
    const staticFields = this.filter.filterParams;

    switch (item.property) {
      case 'Search':
        this.filter.searchObject = new EmcSearchOutput()
        break;

      case 'Status':
        staticFields.statuses = staticFields.statuses.filter(s => s.toString() !== item.selectedValue);
        break;

      case 'Type':
        staticFields.type = null;
        break;

      case 'Area':
        staticFields.selectedAreaModels = staticFields.selectedAreaModels.filter(a => a.name !== item.selectedValue);
        break;

      case 'User':
        staticFields.selectedUserModels = staticFields.selectedUserModels.filter(u => u.name !== item.selectedValue);
        break;

      case 'Transmission Station':
        staticFields.selectedTsModels = staticFields.selectedTsModels.filter(ts => ts.name !== item.selectedValue);
        break;

      case 'Date From':
        staticFields.dateFrom = null;
        break;

      case 'Date To':
        staticFields.dateTo = null;
        break;

      case 'Date Type':
        break;

      default:
        const dfIndex = this.filter.dynamicFilters.findIndex(d =>
          item.property.startsWith(d.attributeLabel)
        );

        if (dfIndex !== -1) {
          const df = this.filter.dynamicFilters[dfIndex];

          if (item.property.endsWith('From')) {
            df.from = null;
          } else if (item.property.endsWith('To')) {
            df.to = null;
          } else {
            if (df.selectedOptions && df.optionDefinitions) {

              const option = df.optionDefinitions.find(opt => opt.optionValue === item.selectedValue);

              if (option) {
                const idToRemove = option.optionId;
                df.selectedOptions = df.selectedOptions.filter(optId => optId !== idToRemove);
              }
            }

            df.optionDefinitions = df.optionDefinitions?.filter(
              opt => opt.optionValue !== item.selectedValue
            );
          }

          const hasOptions = df.selectedOptions && df.selectedOptions.length > 0;
          const hasOptionDefinitions = df.optionDefinitions && df.optionDefinitions.length > 0;
          const hasFromTo = (df.from != null) || (df.to != null);

          if (!hasOptions && !hasFromTo && !hasOptionDefinitions) {
            this.filter.dynamicFilters.splice(dfIndex, 1);
          }
        }
        break;
    }
  }

  download() {
    this.substationService.downloadDynamic(this.filter).subscribe({
      next: (response) => {
        const data = response;
        if (data?.status === 'OK' || data?.status === '200') {
          window.location.href = data.data;
        } else if (data?.status === 'Pending' || data?.status === '600') {
          this.toastr.info(data?.message || '');
        } else this.toastr.error(data?.message || 'Request failed');
      },
      error: (error) => console.log(error),
    });
  }

  private createFilterCards() {
    const items: ChecklistItem[] = [];

    const staticFields = this.filter.filterParams;

    if (this.filter.searchObject.searchValue) {
      items.push(new ChecklistItem('Search', this.filter.searchObject.searchValue, this.mapFilterLabels['Search'], this.mapFilterValues[staticFields.search]));
    }

    staticFields.statuses.forEach(status => {
      const statusValue = status.toString();
      items.push(new ChecklistItem('Status', statusValue, this.mapFilterLabels['Status'], this.mapFilterValues[statusValue]));
    });

    if (staticFields.type != null && staticFields.type !== 0) {
      const typeValue = staticFields.type.toString();
      items.push(new ChecklistItem('Type', typeValue, this.mapFilterLabels['Type'], this.mapFilterValues[typeValue]));
    }

    staticFields.selectedAreaModels.forEach(area => {
      const name = area.name;
      items.push(new ChecklistItem('Area', name, this.mapFilterLabels['Area'], this.mapFilterValues[name]));
    });

    staticFields.selectedUserModels.forEach(user => {
      const name = user.name;
      items.push(new ChecklistItem('User', name, this.mapFilterLabels['User'], this.mapFilterValues[name]));
    });

    staticFields.selectedTsModels.forEach(ts => {
      const name = ts.name;
      items.push(new ChecklistItem('Transmission Station', name, this.mapFilterLabels['Transmission Station'], this.mapFilterValues[name]));
    });

    if (staticFields.dateFrom) {
      items.push(new ChecklistItem(
        'Date From',
        staticFields.dateFrom,
        this.mapFilterLabels['Date From'],
        this.mapFilterValues[staticFields.dateFrom]
      ));
    }

    if (staticFields.dateTo) {
      items.push(new ChecklistItem(
        'Date To',
        staticFields.dateTo,
        this.mapFilterLabels['Date To'],
        this.mapFilterValues[staticFields.dateTo]
      ));
    }

    if ((staticFields.dateFrom || staticFields.dateTo) && staticFields.dateType) {
      items.push(new ChecklistItem(
        'Date Type',
        this.filter.filterParams.dateTypeString,
        this.mapFilterLabels['Date Type'],
        this.mapFilterValues[this.filter.filterParams.dateTypeString]
      ));
    }

    this.filter.dynamicFilters.forEach(df => {
      df.optionDefinitions?.forEach(option => {
        items.push(new ChecklistItem(option.attributeLabel, option.optionValue, this.mapFilterLabels[option.attributeLabel], this.mapFilterValues[option.optionValue]));
      });

      if (df.from) {
        const formatted = df.from.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
        items.push(new ChecklistItem(df.attributeLabel + ' From', formatted, this.mapFilterLabels[df.attributeLabel + ' From'], this.mapFilterValues[formatted]));
      }

      if (df.to) {
        const formatted = df.to.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
        items.push(new ChecklistItem(df.attributeLabel + ' To', formatted, this.mapFilterLabels[df.attributeLabel + ' To'], this.mapFilterValues[formatted]));
      }
    });

    this.checklistItems = items;
  }

}
